import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import './scrollToTopButton.css';
import { FaAnglesUp } from "react-icons/fa6";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {   // show after scrolling 200px
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {isVisible && (
        <button
        className="scrollToTopButton"
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "50px",
            left: "30px",
            zIndex: 9999,
            // background: "#17b4a6ff",
            color: "black",
            border: "none",
            padding: "12px",
            borderRadius: "50%",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
          }}
        >
          <FaAnglesUp size={20} />
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
